export const getMsgWithContact = (title: string, email: string | undefined) => {
  return (
    <>
      {title}.&nbsp;
      {email && (
        <>
          Please
          <a href={`mailto:${email}`} className="ant-btn-link no-decoration">
            &ensp;contact our support
          </a>
        </>
      )}
    </>
  );
};
